import { render, staticRenderFns } from "./ModalEditarCupom.vue?vue&type=template&id=13b3b43f&scoped=true&"
import script from "./ModalEditarCupom.vue?vue&type=script&lang=js&"
export * from "./ModalEditarCupom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b3b43f",
  null
  
)

export default component.exports